import { validationFactory } from '../validation/validation';
/**
 * Validation that requires the property to have a value between the provided values. This validation is inclusive.
 *
 * @param from Minimum possible value
 * @param to Maximum possible value
 */
export var between = validationFactory('between');
//# sourceMappingURL=between.js.map